'use client';

import dynamic from 'next/dynamic';
import type DeeplinkData from '@alltrails/types/DeeplinkData';

const ScrollLimit = dynamic(() => import('@alltrails/user-auth/components/ScrollLimit/ScrollLimit'), { ssr: false });

const ScrollLimitWrapper = ({ deeplinkData }: { deeplinkData: DeeplinkData }) => {
  return <ScrollLimit deeplinkData={deeplinkData} />;
};

export default ScrollLimitWrapper;
